module.exports = __webpack_public_path__ + "ee43f73a17edeb06898d85245eea80c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuGiantSub.png
// module id = 412
// module chunks = 0